module.exports = __webpack_public_path__ + "img/transactions.9a282148.png";